import { render, staticRenderFns } from "./PageExternalGameComplete.vue?vue&type=template&id=f0131bde&scoped=true&"
import script from "./PageExternalGameComplete.vue?vue&type=script&lang=js&"
export * from "./PageExternalGameComplete.vue?vue&type=script&lang=js&"
import style0 from "./PageExternalGameComplete.vue?vue&type=style&index=0&id=f0131bde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0131bde",
  null
  
)

export default component.exports